import * as React from 'react';
// import { useState, useEffect } from 'react';
import { recipientType } from '../../types/Types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Checkbox,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { useRef } from 'react';

interface RowProps {
  idx: number;
  size: number;
  row: recipientType;
  handleRecipientChange: (idx: number, recipient: recipientType) => void;
  handleRecipientDelete: (idx: number) => void;
}
function Row(props: RowProps) {
  const { idx, size, row, handleRecipientChange, handleRecipientDelete } =
    props;
  const [open, setOpen] = React.useState(false);

  // メールアドレスが変わったとき
  const [addressError, setAddressError] = useState(false);
  const addressRef = useRef<any>(null);
  const onChangeAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (addressRef.current) {
      console.dir(addressRef.current);
      if (
        !addressRef.current.value.match(
          /^[a-zA-Z0-9.!#$%&'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        )
      ) {
        setAddressError(true);
      } else {
        setAddressError(false);
      }
      row.address = e.target.value;
      handleRecipientChange(idx, row);
    }
  };

  // 本文への記載が変わったとき
  const onChangeInMessage = (e: React.ChangeEvent<HTMLInputElement>) => {
    row.in_message = e.target.checked ? 1 : 0;
    handleRecipientChange(idx, row);
  };

  // メールへの添付が変わったとき
  const onChangeAttachMedia = (e: React.ChangeEvent<HTMLInputElement>) => {
    row.attach_media = e.target.checked ? 1 : 0;
    handleRecipientChange(idx, row);
  };

  // 着信通知が変わったとき
  const onChangeIncomingNotice = (e: React.ChangeEvent<HTMLInputElement>) => {
    row.incoming_notice = e.target.checked ? 1 : 0;
    handleRecipientChange(idx, row);
  };

  // 削除ボタンクリック時
  const onDeleteClick = () => {
    if (size <= 1) {
      alert('送信先は最低１つ必要です。');
      return -1;
    }
    handleRecipientDelete(idx);
    setOpen(false); // アコーディオンは閉じる
  };

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label='expand row'
            size='small'
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component='th' scope='row'>
          {row.address}
        </TableCell>
        <TableCell align='right'>
          <Checkbox checked={row.in_message === 1} disabled />
        </TableCell>
        <TableCell align='right'>
          <Checkbox checked={row.attach_media === 1} disabled />
        </TableCell>
        <TableCell align='right'>
          <Checkbox checked={row.incoming_notice === 1} disabled />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='center'
                spacing={1}
              >
                <Grid item xs={10} md={10} lg={10}>
                  <TextField
                    error={addressError}
                    inputRef={addressRef}
                    inputProps={{ pattern: '[w-._]+@[w-._]+.[A-Za-z]+' }}
                    label='メールアドレス'
                    fullWidth
                    margin='normal'
                    placeholder='xxxx@example.com'
                    defaultValue={row.address}
                    onChange={onChangeAddress}
                  />
                </Grid>
                <Grid item xs={2} md={2} lg={2}>
                  <IconButton onClick={onDeleteClick}>
                    <HighlightOffIcon fontSize='large' color='error' />
                  </IconButton>
                </Grid>
              </Grid>
              <FormControlLabel
                control={
                  <Switch
                    checked={row.in_message === 1}
                    onChange={onChangeInMessage}
                  />
                }
                label='認識結果を本文に記載する'
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={row.attach_media === 1}
                    onChange={onChangeAttachMedia}
                  />
                }
                label='音声データを添付する'
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={row.incoming_notice === 1}
                    onChange={onChangeIncomingNotice}
                  />
                }
                label='着信通知を送信する'
              />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

interface Props {
  recipients: recipientType[] | undefined;
  handleRecipientChange: (idx: number, recipient: recipientType) => void;
  handleRecipientDelete: (idx: number) => void;
}
export default function CollapsibleTable(props: Props) {
  const { recipients, handleRecipientChange, handleRecipientDelete } = props;

  return (
    <TableContainer component={Paper}>
      <Table aria-label='collapsible table'>
        <TableHead>
          <TableRow>
            <TableCell />
            <TableCell>メールアドレス</TableCell>
            <TableCell align='right'>本文</TableCell>
            <TableCell align='right'>添付</TableCell>
            <TableCell align='right'>着信通知</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {recipients?.map((recipient, idx) => (
            <Row
              key={idx}
              size={recipients.length}
              idx={idx}
              row={recipient}
              handleRecipientChange={(idx: number, recipient: recipientType) =>
                handleRecipientChange(idx, recipient)
              }
              handleRecipientDelete={(idx: number) => {
                handleRecipientDelete(idx);
              }}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
